const DEPLOYED_LIVE_DATA_PHP_PATH = "/wp-content/uploads/test/live-data-sync.php";
const ROOT_LIVE_DATA_PHP_PATH = "/live-data-sync.php";
const WORDPRESS_ORIGIN =
  (typeof import.meta !== "undefined" && import.meta.env && import.meta.env.VITE_WORDPRESS_ORIGIN) ||
  "https://travel.rethinkways.com";

const LIVE_DATA_REST_PATHS = [
  "/wp-json/trw/v1/live-data",
  "/?rest_route=/trw/v1/live-data",
];

const SUPER_DEALS_REST_PATHS = [
  "/wp-json/trw/v1/super-deals",
  "/?rest_route=/trw/v1/super-deals",
];

function uniqueUrls(urls) {
  return [...new Set(urls.map((url) => String(url || "").trim()).filter(Boolean))];
}

function getAppBaseUrl() {
  if (typeof import.meta !== "undefined" && import.meta.env && typeof import.meta.env.BASE_URL === "string") {
    return import.meta.env.BASE_URL || "/";
  }
  return "/";
}

function isLocalRuntime() {
  if (typeof window === "undefined") return false;
  return /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname);
}

function toWordPressUrl(pathname = "") {
  if (isLocalRuntime()) return String(pathname || "").trim() || "/";
  return new URL(pathname, WORDPRESS_ORIGIN).toString();
}

function joinBaseUrl(pathname = "") {
  const baseUrl = getAppBaseUrl();
  const normalizedBase = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
  const normalizedPath = String(pathname || "").replace(/^\/+/, "");
  return `${normalizedBase}${normalizedPath}`;
}

function getDeployedPhpUrl() {
  if (isLocalRuntime()) return DEPLOYED_LIVE_DATA_PHP_PATH;
  return new URL(DEPLOYED_LIVE_DATA_PHP_PATH, WORDPRESS_ORIGIN).toString();
}

function getRootPhpUrl() {
  if (isLocalRuntime()) return ROOT_LIVE_DATA_PHP_PATH;
  return new URL(ROOT_LIVE_DATA_PHP_PATH, WORDPRESS_ORIGIN).toString();
}

function normalizeSyncUrl(url) {
  const raw = String(url || "").trim();
  if (!raw) return "";

  try {
    const parsed = new URL(raw, typeof window !== "undefined" ? window.location.origin : "https://travel.rethinkways.com");
    if (/\/live-data-sync\.php$/i.test(parsed.pathname)) {
      return isLocalRuntime() ? DEPLOYED_LIVE_DATA_PHP_PATH : getDeployedPhpUrl();
    }
    if (/\/live-data-sync\.php$/i.test(parsed.pathname.replace(/^\/wp-content\/uploads\/test/, ""))) {
      return isLocalRuntime() ? DEPLOYED_LIVE_DATA_PHP_PATH : getDeployedPhpUrl();
    }
    if (isLocalRuntime() && parsed.origin === WORDPRESS_ORIGIN) {
      return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    }
    return raw;
  } catch {
    if (/^\/?live-data-sync\.php$/i.test(raw) || /\/live-data-sync\.php$/i.test(raw)) {
      return isLocalRuntime() ? DEPLOYED_LIVE_DATA_PHP_PATH : getDeployedPhpUrl();
    }
    return raw;
  }
}

function getExplicitSyncUrls() {
  if (typeof window === "undefined") return [];
  return [
    ...(String(window.TRW_LIVE_DATA_SYNC_URLS || "")).split(","),
    ...(String(window.TRW_LIVE_DATA_SYNC_URL || "")).split(","),
    ...(String(window.TRW_SUPER_DEALS_SYNC_URLS || "")).split(","),
    ...(String(window.TRW_SUPER_DEALS_SYNC_URL || "")).split(","),
    ...(String(window.TRW_SYNC_URL || "")).split(","),
  ].map(normalizeSyncUrl);
}

export function getLiveDataSyncUrls({ includeSuperDealsRest = false, includeRest = true } = {}) {
  if (isLocalRuntime()) {
    return [];
  }

  const urls = [];

  if (includeRest) {
    urls.push(...LIVE_DATA_REST_PATHS.map(toWordPressUrl));
    if (includeSuperDealsRest) {
      urls.push(...SUPER_DEALS_REST_PATHS.map(toWordPressUrl));
    }
  }

  urls.push(
    ...getExplicitSyncUrls().filter((url) => !/\/live-data-sync\.php(?:[?#].*)?$/i.test(url))
  );

  return uniqueUrls(urls);
}

export function getLiveDataUploadUrls() {
  if (isLocalRuntime()) {
    return [];
  }

  return uniqueUrls([
    getDeployedPhpUrl(),
    getRootPhpUrl(),
  ]);
}
